/*
* Pipeline Theme
*/

(function() {

  function initBidirectionalSync() {
    var slideshow = document.querySelector('[data-product-slideshow]');
    if (!slideshow) return;

    var container = slideshow.closest('[data-section-type="product"]');
    if (!container) container = slideshow.closest('.product-section');
    if (!container) container = document.querySelector('[data-section-type="product"]');
    if (!container) return;

    var productJson = container.querySelector('[data-product-json]');
    var optionsJson = container.querySelector('[data-product-options-json]');
    if (!productJson || !optionsJson) return;

    var product = JSON.parse(productJson.innerHTML);
    var options = JSON.parse(optionsJson.innerHTML).options;

    var thumbContainer = container.querySelector('[data-product-thumbs]');
    if (!thumbContainer) return;

    var thumbnails = thumbContainer.querySelectorAll('[data-thumbnail]');

    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function(e) {
        var mediaId = parseInt(thumb.getAttribute('data-media-id'), 10);
        if (!mediaId) return;

        var matchingVariant = null;
        for (var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];
          if (v.featured_media && v.featured_media.id === mediaId) {
            matchingVariant = v;
            break;
          }
        }

        if (!matchingVariant) return;

        var alreadySelected = true;
        for (var index = 0; index < matchingVariant.options.length; index++) {
          var optionValue = matchingVariant.options[index];
          var optionName = options[index].name;
          var radio = container.querySelector('input[type="radio"][name="options[' + optionName + ']"][value="' + optionValue + '"]');
          if (radio && !radio.checked) {
            alreadySelected = false;
            break;
          }
        }

        if (alreadySelected) return;

        var scrollX = window.scrollX;
        var scrollY = window.scrollY;

        for (var index = 0; index < matchingVariant.options.length; index++) {
          var optionValue = matchingVariant.options[index];
          var optionName = options[index].name;

          var radio = container.querySelector('input[type="radio"][name="options[' + optionName + ']"][value="' + optionValue + '"]');
          if (radio && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
            continue;
          }

          var select = container.querySelector('select[id="Option' + (index + 1) + '"]');
          if (select && select.value !== optionValue) {
            select.value = optionValue;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        setTimeout(function() {
          window.scrollTo(scrollX, scrollY);
        }, 50);
      });
    });
  }

  // Fix scroll bug: blur thumbnail after click
  function initThumbnailBlurFix() {
    var thumbContainer = document.querySelector('[data-product-thumbs]');
    if (!thumbContainer) return;

    thumbContainer.querySelectorAll('[data-thumbnail]').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        setTimeout(function() {
          if (document.activeElement) {
            document.activeElement.blur();
          }
        }, 300);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initBidirectionalSync, 500);
      setTimeout(initThumbnailBlurFix, 500);
    });
  } else {
    setTimeout(initBidirectionalSync, 500);
    setTimeout(initThumbnailBlurFix, 500);
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(initBidirectionalSync, 500);
    setTimeout(initThumbnailBlurFix, 500);
  });

})();
